import { Component, Input } from '@angular/core';
import { PessoaEndereco } from '../pessoa-endereco';
import { PessoaContato } from '../../contato';

@Component({
    selector: 'sgt-pessoa-endereco-info-card',
    templateUrl: './pessoa-endereco-info-card.component.html',
    styleUrls: ['./pessoa-endereco-info-card.component.less']
})
export class PessoaEnderecoInfoCardComponent {
    @Input() endereco: PessoaEndereco;
    @Input() contato: PessoaContato;
}
